import React, { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../firebase-config";
import { useNavigate } from "react-router-dom";
import { setStaff } from "../redux/staffReducer";
import { useDispatch, useSelector } from "react-redux";
import { collection, deleteDoc, doc, getDoc, getDocs, orderBy, query, setDoc, where } from "firebase/firestore";
import { getFirebaseDocs } from "../utils/common";
import Dropdown from '../components/Dropdown'
import toast from 'react-hot-toast';
import ModalComponent from "../components/Modal";

const Admin = () => {


    const [existingBookings, setExistingBookings] = useState([])
    const [loading, setLoading] = useState(false)
    const [currentTab, setCurrentTab] = useState('Bookings')
    const [search, setSearch] = useState('')
    const [ridesInfo, setRidesInfo] = useState([])
    const [timeslotInfo, setTimeslotInfo] = useState([])

    const [scheduleChosenDate, setScheduleChosenDate] = useState({ label: '29', value: '29' })
    const [scheduleBookingInfo, setScheduleBookingInfo] = useState({ 29: [], 30: [] })
    const [chosenRide, setChosenRide] = useState()
    const [chosenTime, setChosenTime] = useState()
    const [slotQuantityObj, setSlotQuantityObj] = useState()
    const [showDeleteBookingConfirmation, setShowDeleteBookingConfirmation] = useState(false)

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const staff = useSelector((state) => state.staff.value)

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (!user) {
                navigate('/login')
            } else {
                dispatch(setStaff(user.uid))
            }
        })
        return () => unsubscribe()
    }, [])

    useEffect(() => {
        if (staff) {
            setLoading(true)
            document.getElementById('back-to-admin').style.display = 'none'
            fetchBookings()
            fetchRidesInfo()
            fetchTimeslotInfo()
        }
    }, [staff])

    useEffect(() => {
        if (chosenTime && scheduleChosenDate && chosenRide && currentTab === 'Schedule') {
            const ride = scheduleBookingInfo[scheduleChosenDate.value].find(ride => chosenRide.value === ride.name)
            if (ride) {
                const timeSlot = ride.rideTimes.find(ts => ts.name === chosenTime.value)
                setSlotQuantityObj({ name: timeSlot.name, quantity: timeSlot.quantity, docId: `${ride.id}-${scheduleChosenDate.value}` })
            }
        }
    }, [chosenTime, chosenRide, currentTab])


    useEffect(() => {
        if (existingBookings.length > 0 && timeslotInfo.length > 0 && ridesInfo.length > 0) {
            generateReportTable()
        }
    }, [existingBookings, timeslotInfo, ridesInfo])

    const fetchTimeslotInfo = async () => {
        const records = await getFirebaseDocs(await getDocs(query(collection(db, 'timeslots'))))
        setTimeslotInfo(records)
    }



    const fetchTimesForRide = (id, dt) => {
        const matchingDoc = timeslotInfo.find(row => row.id === `${id}-${dt}`)
        return matchingDoc.times.map(ts => {
            let participants = []
            // console.log(existingBookings)
            for (let existBook of existingBookings) {
                if (existBook.rides.includes(`${id}-${dt}-${ts.name}`)) {
                    const { email, name, phone, birth_date, userId } = existBook
                    participants.push({ email, name, phone, birth_date, userId })
                }
            }
            return ({ ...ts, participants })
        })
    }

    const generateReportTable = () => {

        let groupedRidesByDate = {
            '29': ridesInfo.map(({ id, name }) => ({ id, name, rideTimes: fetchTimesForRide(id, '29') })),
            '30': ridesInfo.map(({ id, name }) => ({ id, name, rideTimes: fetchTimesForRide(id, '30') })),
        }
        setScheduleBookingInfo(groupedRidesByDate)
    }

    const fetchRidesInfo = async () => {
        const ridesData = await (await getDoc(doc(db, 'rides', '29'))).data()
        setRidesInfo(ridesData.data.filter(r => !r.disabled))
    }


    const fetchBookings = async () => {
        const records = await getFirebaseDocs(await getDocs(query(collection(db, 'bookings'), orderBy('Created', 'desc'))))

        const userDatas = await getFirebaseDocs(await getDocs(query(collection(db, 'users'))))

        let finalData = []
        for (let rec of records) {
            // const userData = await (await getDoc(doc(db, 'users', rec.userId))).data()

            const userData = userDatas.find(r => r.id === rec.userId)

            // console.log('userData', userData)

            if (userData) {
                const { email, name, phone, date } = userData
                finalData.push({ ...rec, email, name, phone, birth_date: date })
            }
        }
        setLoading(false)
        setExistingBookings(finalData)
    }


    const editBooking = userId => {
        window.localStorage.setItem('config:userId', userId)
        // console.log('userId', userId)
        document.getElementById('back-to-admin').style.display = 'flex'
        navigate('/')
    }

    const deleteBooking = async () => {
        const userData = await getFirebaseDocs(await getDocs(await query(collection(db, 'bookings'), where('userId', '==', showDeleteBookingConfirmation))))
        // console.log('userData', userData)
        if (userData && userData.length === 1) {
            const docId = userData[0].id
            await deleteDoc(doc(db, 'bookings', docId))
        }
        setShowDeleteBookingConfirmation(false)
        // fetchBookings()
        window.location.reload()
    }

    const searchFilter = row => search ? (row.name.toLowerCase().includes(search.toLowerCase()) || row.email.toLowerCase().includes(search.toLowerCase()) || row.phone.toLowerCase().includes(search.toLowerCase()) || row.birth_date.toLowerCase().includes(search.toLowerCase())) : true

    const findRideName = rideId => ridesInfo.find(({ id }) => id === rideId) && ridesInfo.find(({ id }) => id === rideId).name

    const formatRides = rides => {

        let groupedRides = {
            '29': [],
            '30': []
        }

        for (let ride of rides) {
            const rideChunks = ride.split('-')
            groupedRides[rideChunks[1]].push(`${findRideName(rideChunks[0])}: ${rideChunks[2]}`)
        }

        return (<>
            {
                groupedRides['29'].length > 0 &&
                <>
                    <div style={{ fontWeight: 'bold' }}>29th</div>
                    <div>{groupedRides['29'].join(', ')}</div>
                </>
            }
            {
                groupedRides['30'].length > 0 && <>
                    <div style={{ fontWeight: 'bold' }}>30th</div>
                    <div>{groupedRides['30'].join(', ')}</div>
                </>
            }

        </>)
    }

    const updateQuantityOfTimeslot = async () => {
        const timeslotInfoFromDb = await (await getDoc(doc(db, 'timeslots', slotQuantityObj.docId))).data()
        // console.log(timeslotInfoFromDb)
        if (timeslotInfoFromDb && parseInt(slotQuantityObj.quantity)) {
            const newTimes = timeslotInfoFromDb.times.map(r => r.name === slotQuantityObj.name ? ({ ...r, quantity: parseInt(slotQuantityObj.quantity) }) : r)
            // console.log(newTimes)
            await setDoc(doc(db, 'timeslots', slotQuantityObj.docId), { times: newTimes })
            toast.success('Quantity has been updated. Reloading page!')
            setTimeout(() => {
                window.location.reload()
            }, 1000)
        }
    }


    const renderScheduleInfo = (ride, dt) => <div key={ride.id + `-${dt}`}>
        <h3 style={{ margin: '10px 0 0' }}>{ride.name}</h3>
        {ride.rideTimes.filter(ts => chosenTime ? ts.name === chosenTime.value : true).map(ts => <div key={ride.id + `-${dt}` + ts.name}>
            <div style={{ display: 'flex' }}>
                <h4 style={{ margin: '20px 0 10px' }}>{ts.name}  ({ts.participants.length} of {parseInt(ts.quantity)} seats booked)</h4>
                {chosenTime && slotQuantityObj && <div style={{ display: 'flex', alignItems: 'center' }} className="hide-print">
                    <label style={{ marginTop: '10px', marginLeft: '10px', color: '#fac55f' }}>Update Quantity: </label>
                    <input style={{ width: '80px', height: '20px', marginLeft: '3px' }} value={parseInt(slotQuantityObj.quantity) || ''} onChange={(e) => setSlotQuantityObj({ ...slotQuantityObj, quantity: (e.target.value) })} />
                    {parseInt(slotQuantityObj.quantity) >= ts.participants.length && parseInt(slotQuantityObj.quantity) !== parseInt(ts.quantity) && <button onClick={updateQuantityOfTimeslot} style={{ margin: '10px', padding: '5px 10px', height: '40px', backgroundColor: '#f2625b' }}>Update</button>}
                </div>}
            </div>
            <table>
                <thead>
                    <tr>
                        <th>{'Name'}</th>
                        <th>{'DOB'}</th>
                        <th>{'Email'}</th>
                        <th>{'Mobile'}</th>
                    </tr>
                </thead>
                <tbody>
                    {ts.participants.map((participant, idx) => <tr key={participant.userId + idx}>
                        <td>{participant.name}</td>
                        <td>{participant.birth_date}</td>
                        <td>{participant.email}</td>
                        <td>{participant.phone}</td>
                    </tr>)}
                </tbody>
            </table>
        </div>)
        }
    </div>

    const timeslotOptions = scheduleBookingInfo[scheduleChosenDate.value].filter(ride => chosenRide ? (chosenRide.value === ride.name) : false).map(row => row.rideTimes.map(v => v.name)).flat()

    return (<div className="admin-wrapper">
        <div>

            <div className="tabBar">
                {['Bookings', 'Schedule'].map(tab => <div className={`hover ${currentTab === tab ? 'tabButtonActive' : 'tabButton'}`} key={tab} onClick={() => setCurrentTab(tab)}>{tab}</div>)}
            </div>
        </div>

        <ModalComponent showModal={!!showDeleteBookingConfirmation} setShowModal={setShowDeleteBookingConfirmation}>
            <> <h2 style={{ textAlign: 'center' }}>Confirm delete Booking?</h2>
                {/* <p style={{ textAlign: 'center' }}> </p> */}
                <div style={{ display: 'flex' }}>
                    <button onClick={deleteBooking}>Delete</button>
                    <button onClick={() => setShowDeleteBookingConfirmation(false)}>Cancel</button>
                </div>
            </>
        </ModalComponent>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <div style={{ display: 'flex' }}>
                <h1> {currentTab}</h1>
                <button style={{ marginLeft: '10px', backgroundColor: '#fac55f', padding: '10px' }} onClick={() => window.print()}> Print</button>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {currentTab === 'Bookings' ? <input type="text" style={{ width: '200px' }} value={search} className={''} placeholder="Search" onChange={({ target: { value } }) => setSearch(value)} />
                    :
                    <>
                        <div style={{ width: '200px', marginTop: '-15px' }}>
                            <Dropdown options={['29', '30']} value={scheduleChosenDate} setValue={setScheduleChosenDate} label={'Date'} errorFields={[]} name={'date'} />
                        </div>
                        <div style={{ width: '200px', marginLeft: '20px', marginTop: '-15px' }}>
                            <Dropdown options={ridesInfo.map(r => r.name)} value={chosenRide} setValue={setChosenRide} label={'Ride'} errorFields={[]} name={'ride'} />
                        </div>
                        <div style={{ width: '200px', marginLeft: '20px', marginTop: '-15px' }}>
                            <Dropdown clearable options={timeslotOptions} value={chosenTime} setValue={setChosenTime} label={'Time'} errorFields={[]} name={'time'} />
                        </div>
                    </>
                }
            </div>
        </div>
        {
            loading ? 'Loading...' :
                (currentTab === 'Schedule' ?
                    <>
                        <h3 style={{ marginBottom: '0px' }}>{scheduleChosenDate.value} Jul 2023</h3>
                        {scheduleBookingInfo[scheduleChosenDate.value].filter(ride => chosenRide ? (chosenRide.value === ride.name) : false).map(ride => renderScheduleInfo(ride, scheduleChosenDate.value))}

                    </>
                    : <table>
                        <thead>
                            <tr>
                                <th>{'Name'}</th>
                                <th>{'DOB'}</th>
                                <th>{'Email'}</th>
                                <th>{'Mobile'}</th>
                                <th>{'Rides Booked'}</th>
                                <th>{'Edit'}</th>
                                <th>{'Delete'}</th>
                                {/* <th>{'Delete'}</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {existingBookings.filter(row => searchFilter(row)).map(({ name, birth_date, email, phone, userId, rides }) =>
                                <tr key={userId}>
                                    <td>{name}</td>
                                    <td>{birth_date}</td>
                                    <td>{email}</td>
                                    <td>{phone}</td>
                                    <td>
                                        {formatRides(rides)}
                                    </td>
                                    <td>
                                        <div className="hover" style={{ color: '#34bdab' }} onClick={() => editBooking(userId)}> {'Edit'}</div>
                                    </td>
                                    <td>
                                        <div className="hover" style={{ color: '#f2625b' }} onClick={() => setShowDeleteBookingConfirmation(userId)}> {'Delete'}</div>
                                    </td>
                                    {/* <td>
                                    <div className="hover" style={{ color: '#f2625b' }} onClick={() => editBooking(userId)}> {'Delete'}</div>
                                </td> */}
                                </tr>
                            )}
                        </tbody>
                    </table>)
        }


    </div >)
}


export default Admin